module.exports = "data:application/x-font-ttf;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJiMDY4NzFmMjgxZmVlNmIyNDFkNjA1ODJhZTkzNjliOS50dGYiOw=="


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/fontawesome/fontawesome-webfont.ttf?v=4.7.0
// module id = 1480
// module chunks = 0